(function ($) {
    var map;
    function removeParams(sParam){
        var url = window.location.href.split('?')[0]+'?';
        var sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;
    
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] !== sParam) {
                url = url + sParameterName[0] + '=' + sParameterName[1] + '&';
            }
        }
        return url.substring(0,url.length-1);
    }

    //Variables for grouping
    //var provinceMarkersGroups = [];
    //var destination_markers = new L.markerClusterGroup();
    function initLLProvinceMap(el_id) {
        var $el = $('#'+el_id);
        var zoomLvl = $el.data('zoom');
        var map = L.map(el_id).setView([$el.data('center-lat'), $el.data('center-lng')], zoomLvl);
        
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(map);

        var $markers = $('.marker-def');
        var i=0;
        $markers.each(function(index){
            var lat = $(this).data('lat');
            var lng = $(this).data('lng');
            var icon = $(this).data('icon');
            var marker = '';
            if(icon!==""){
                var markerIcon = L.icon({
                    iconUrl: icon,
                    iconSize: [32, 45],
                });
                marker = L.marker([lat, lng],{icon: markerIcon}).bindPopup($(this).html());
            }
            else{
                marker = L.marker([lat, lng]).bindPopup($(this).html());
            }
            //For grouping marker
            //provinceMarkersGroups.push(marker);
            //Comment below line to disable individual marker and enable
            marker.addTo(map);
            var locindex = index;
            $('.map-destination').eq(locindex).on('click',function(e){
                e.preventDefault();
                map.flyTo(new L.LatLng(lat, lng),10);
                marker.openPopup();        
                if($('.map-destination-list').hasClass('active')){
                    $('.map-destination-list').removeClass('active');
                }
            });
            $('.map-destination').eq(locindex).mouseenter(function(e){                
                $(marker._icon).addClass('hover');      
            });
            $('.map-destination').eq(locindex).mouseleave(function(e){                
                $(marker._icon).removeClass('hover');      
            });
            i++;
        });
        return map;
    }

    function initTheme(){
        $(".select-sorting").resizeselect();
        $(".weather-month-sel").resizeselect();

        tippy('.help-tip', {
            theme: 'vakplaats',
            content(reference) {
                var id = reference.getAttribute('data-template');
                var template = document.getElementById(id);
                return template.innerHTML;
            },
            allowHTML: true,
        });

        //Function to apply close events on document click
        $(document).click(function(e) {
            $('.filter-by.active').removeClass('active');            
        });
        $('.destination-view-switches a').on('click',function(e){
            e.preventDefault();
            if(!$(this).hasClass('active')){                
                var currVC = $('.destination-view-switches a.active').data('tab');
                $('.destination-view-switches a.active').removeClass('active');
                $('#'+currVC).addClass('hidden');

                $(this).addClass('active');
                var tabVC = $(this).data('tab');
                $('#'+tabVC).removeClass('hidden');

                if(tabVC==='map-view'){
                    if(map === undefined || map === null ){
                        map = initLLProvinceMap( 'acf-province-map' );
                    }
                }
            }
        });

        $(document).on('click','.map-goto-top .showdestination',function(){
            $('.map-destination-list').addClass('active');
        });

        $(document).on('click','.province-map-wrapper .map-destination-list .close',function(){
            $('.map-destination-list').removeClass('active');            
        });
        
        $("#search-destination").on("keyup", function() {
            var value = $(this).val().toLowerCase();
            $(".map-d-list .map-destination").filter(function() {
                $(this).parent().toggle($(this).text().toLowerCase().indexOf(value) > -1);
            });
        });
    }

    

    function filterDestinations(){
        var tc='';
		if($('.filter-options-inputs[data-fpname="tc"]').find('input[name="tc[]"]:checked').length > 0){
            tc = $('.filter-options-inputs[data-fpname="tc"]').find('input[name="tc[]"]:checked').map(function() {
                return this.value;
            }).get().join(',');
        }
        var ac='';
		if($('.filter-options-inputs[data-fpname="ac"]').find('input[name="ac[]"]:checked').length > 0){
            ac = $('.filter-options-inputs[data-fpname="ac"]').find('input[name="ac[]"]:checked').map(function() {
                return this.value;
            }).get().join(',');
        }	
        var country='';
		if($('.filter-options-inputs[data-fpname="c"]').find('input[name="c[]"]:checked').length > 0){
            country = $('.filter-options-inputs[data-fpname="c"]').find('input[name="c[]"]:checked').map(function() {
                return this.value;
            }).get().join(',');
        }

        if($('input[name="fw"]').length){
            var weatherM = $('select[name="wm"]').val();
            var weatherRange = $('input[name="fw"]').val();
        }

        var ordering = $('.select-sorting').val();

		var rUriQstring = '';
        rUriQstring += country!=='' ? (rUriQstring!=='' ? '&c='+country : '?c='+country ) : '';
        rUriQstring += tc!=='' ? (rUriQstring!=='' ? '&tc='+tc : '?tc='+tc ): '';
        rUriQstring += ac!=='' ? (rUriQstring!=='' ? '&ac='+ac : '?ac='+ac ): '';        

        if($('input[name="fw"]').length){
            rUriQstring += weatherM!=='' ? (rUriQstring!=='' ? '&wm='+weatherM : '?wm='+weatherM ): '';
            rUriQstring += weatherRange!=='' ? (rUriQstring!=='' ? '&fw='+weatherRange : '?fw='+weatherRange ): '';
        }

        rUriQstring += ordering!=='' ? (rUriQstring!=='' ? '&so='+ordering : '?so='+ordering ) : '';
		var rUri = $('.destination-filter-form').attr('action');
        if($('input[name="fw"]').length){
            var weatherAttr = weatherRange.split('~');
        }
        $.ajax({
            method: 'GET',
            url: rUri + rUriQstring,
            dataType: 'html',
            beforeSend:function(xhr){
                $('.ajax-loader').addClass('show');
            },
            success: function(response) {
                var doc = new DOMParser().parseFromString(response, 'text/html');

                var activeTab=$('.destination-view-switches a.active').data('tab');
                $(doc).find('.filter-result .container').addClass('hidden');
                $(doc).find('#'+activeTab).removeClass('hidden');

                if($('.filter-bar-wrapper').hasClass('fixed')){
                    $(doc).find('.filter-bar').addClass('fixed');
                }
                
                var resultHtml = $(doc).find('.filter-result').html();
                var filterHtml = $(doc).find('.filter-bar-wrapper').html();

                $('.filter-result').html(resultHtml);
                $('.filter-bar-wrapper').html(filterHtml);
                window.history.pushState("Filtered", "", rUri + rUriQstring);
                $('.ajax-loader').removeClass('show');

                if($( "#weather-range" ).length){
                    var tmin = parseInt($( "#weather-range" ).data('min'));
                    var tmax = parseInt($( "#weather-range" ).data('max'));
                    $( "#weather-range" ).slider({
                        range: true,
                        min: tmin,
                        max: tmax,
                        values: [ weatherAttr[0], weatherAttr[1] ],
                        slide: function( event, ui ) {
                            $( "#selected-weather-min" ).text( ui.values[ 0 ]+'°C');
                            $( "#selected-weather-max" ).text( ui.values[ 1 ]+'°C');
                            $( "#fw" ).val( ui.values[ 0 ] + "~" + ui.values[ 1 ] );
                        },
                        stop: function( event, ui ) {
                            filterDestinations();
                        }
                    });

                    $( "#selected-weather-min" ).text( $( "#weather-range" ).slider( "values", 0 )+'°C');
                    $( "#selected-weather-max" ).text( $( "#weather-range" ).slider( "values", 1 )+'°C' );
                    $( "#fw" ).val( $( "#weather-range" ).slider( "values", 0 ) +"~" + $( "#weather-range" ).slider( "values", 1 ) );
                }

                initTheme();
                
                if($(doc).find('.acf-province-map-wrap').length){
                    var mapdlistHtml = $(doc).find('.map-d-list').html();
                    var markersListHtml = $(doc).find('.markers-list').html();
                    var mapHtml = $(doc).find('.acf-province-map-wrap').html();

                    $('.map-d-list').html(mapdlistHtml);
                    $('.markers-list').html(markersListHtml);
                    $('.acf-province-map-wrap').html(mapHtml);
                    if(map!==undefined && map!==null){
                        map.off();
                        map.remove();
                        map=null;
                    }     
                    
                    if(activeTab === 'map-view'){
                        map = initLLProvinceMap( 'acf-province-map' );                        
                    }
                }

                var offset;
                offset = $('.filter-result').offset().top - 260;
                $('html, body').animate({
                    scrollTop: offset
                }, 600, function () { });
            }
        });
		//document.location = rUri + rUriQstring;
    }


    $(function() {
        initTheme();        
        //Function to open filter option
        $(document).on('click','.filter-select-input',function(e){
            e.preventDefault();
            e.stopPropagation();
            var thisParent = $(this).parents('.filter-by');
            if(!thisParent.hasClass('active')){
                $('.filter-by.active').removeClass('active');
                thisParent.addClass('active');
            }
            else{
                thisParent.removeClass('active');
            }
        });

        $(document).on('click','.filter-options',function(e){
            e.stopPropagation();
        });

        $(document).on('change','.select-sorting',function(e){
            filterDestinations();
        });

        $(document).on('change','.destination-filter-form input[type="checkbox"]',function(e){
			if(!$(this).parent().hasClass('disable')){
				filterDestinations();
			}
            else{
                e.preventDefault();
            }
		});

        if($( "#weather-range" ).length){
            var tmin = parseInt($( "#weather-range" ).data('min'));
            var tmax = parseInt($( "#weather-range" ).data('max'));
    
            var dmin = parseInt($( "#weather-range" ).data('dmin'));
            var dmax = parseInt($( "#weather-range" ).data('dmax'));
    
            $( "#weather-range" ).slider({
                range: true,
                min: tmin,
                max: tmax,
                values: [ dmin, dmax ],
                slide: function( event, ui ) {
                    $( "#selected-weather-min" ).text( ui.values[ 0 ]+'°C');
                    $( "#selected-weather-max" ).text( ui.values[ 1 ]+'°C');
                    $( "#fw" ).val( ui.values[ 0 ] + "~" + ui.values[ 1 ] );
                } ,
                stop: function( event, ui ) {
                    filterDestinations();
                }
            });
    
            $( "#selected-weather-min" ).text( $( "#weather-range" ).slider( "values", 0 )+'°C');
            $( "#selected-weather-max" ).text( $( "#weather-range" ).slider( "values", 1 )+'°C' );
            $( "#fw" ).val( $( "#weather-range" ).slider( "values", 0 ) +"~" + $( "#weather-range" ).slider( "values", 1 ) );
    
            $(document).on('change','.weather-month-sel',function(e){
                var thisobj = $(this);
                $.ajax({
                    method: 'GET',
                    url: tatilAajx.ajaxUrl,
                    dataType: 'json',
                    data:{ 'month':thisobj.val(),'action':'weather_range'},
                    beforeSend:function(xhr){
                        //$('.ajax-loader').addClass('show');
                    },
                    success: function(response) {
                        $('#weather-range').slider( "option", "min", parseInt(response.tmin));
                        $('#weather-range').slider( "option", "max", parseInt(response.tmax));
    
                        $('#weather-range').slider("option", "values", [parseInt(response.tmin),parseInt(response.tmax)]);
                        
                        $( "#selected-weather-min" ).text( $( "#weather-range" ).slider( "values", 0 )+'°C');
                        $( "#selected-weather-max" ).text( $( "#weather-range" ).slider( "values", 1 )+'°C' );
                        $( "#fw" ).val( $( "#weather-range" ).slider( "values", 0 ) +"~" + $( "#weather-range" ).slider( "values", 1 ) );
    
                        filterDestinations();
                    }
                });
            });
        }

        $(document).on('click','.selected-filter.has-remove',function(e){
            e.preventDefault();
            
            var filter = $(this).data('filter');
            var filterval = $(this).data('filter-val');
            if(typeof $(this).data('filter-for') !== 'undefined'){
                $('input[name="'+filter+'[]"][value="'+filterval+'"]').click();
            }
            else{
                if(filter!='cs'){
                    $('input[name="'+filter+'[]"][value="'+filterval+'"]').click();
                }
                else{
                    window.location = removeParams('cs');
                }
            }
        });
        
        $(document).on('click','.clear-all-filters',function(e){
            e.preventDefault();
            $('.destination-filter-form').find('input[type="checkbox"]').prop('checked',false);

            var tmin = parseInt($( "#weather-range" ).data('min'));
            var tmax = parseInt($( "#weather-range" ).data('max'));
            $('#weather-range').slider("option", "values", [tmin,tmax]);
            $( "#fw" ).val( $( "#weather-range" ).data('min') +"~" + $( "#weather-range" ).data('max') );

            filterDestinations();            
        });

        const sitefilter = document.querySelector(".filter-bar");
        const sitefilterTop = sitefilter.getBoundingClientRect().top + window.pageYOffset;
        
        window.addEventListener("scroll", () => {
            if (window.pageYOffset  > sitefilterTop ) {
                $('.filter-bar-wrapper').addClass('fixed');
                $('.filter-bar').addClass('fixed');
            } else {
                $('.filter-bar').removeClass('fixed');
                $('.filter-bar-wrapper').removeClass('fixed');
            }
        });
    });
})(jQuery);